import React, { useMemo, useState } from "react";
import { Avatar, Empty, Flex, message, Tag, Tooltip } from "antd";
import { Table } from "./TaskList.styled";
import { useLocation, useNavigate } from "react-router-dom";
import {
  createQuery,
  queryStringToObject,
  removeUndefinedFields,
  removeUnusedFields,
} from "../filters/Filter.utils";

import { useTaskPageContetnSize } from "../../pages/task-page/useTaskPageContetnSize";
import { useQuery, useQueryClient } from "react-query";
import { getTasks, getUsers } from "../../../service/client";
import {
  cratehardcodedControlsArray,
  createTaskFilterControls,
  dataSourceConventer,
} from "./TaskList.utils";
import { useFilters } from "../../templates/filter-context/useFilters";
import { TaskListHeader } from "../../molecules/";
import { TaskListWraper } from "../";
import { Filters } from "../filters/Filters";
import { columns as baseColumns } from "./TaskList.consts";
import {DataType} from "./TaskList.types";

export const TasksList: React.FC<{ defaultFilters?: any }> = ({
  defaultFilters,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const paramas = queryStringToObject(location.search);
  const queryClient = useQueryClient();

  const { tableHeight } = useTaskPageContetnSize();
  const { filters } = useFilters();
  const [limit, setLimit] = useState(20);
  const [offset, setOffSet] = useState(0);
  const [page, setPage] = useState(1);

  // Filters from the URL win over page defaults so deep links keep working;
  // context filters take over as soon as any component sets them.
  const urlFilters = useMemo(() => {
    const parsed = removeUnusedFields(
      removeUndefinedFields(queryStringToObject(location.search))
    );
    return Object.keys(parsed).length > 0 ? parsed : undefined;
  }, [location.search]);

  const effectiveFilters = filters ?? urlFilters ?? defaultFilters;

  const query = createQuery({ ...effectiveFilters, limit: limit, offset: offset });

  const { data: users } = useQuery<any, Error>(["/users"], () => getUsers());

  const hardcodedControls = useMemo(() => cratehardcodedControlsArray(users), [users]);
  const taskFilterControls = useMemo(() => createTaskFilterControls(users), [users]);

  const resetPagination = () => {
    setOffSet(0);
    setPage(1);
  };

  const { data, isFetching } = useQuery<any, Error>(
    ["/tasks", query],
    () => getTasks(query)
  );

  const total = data?.count ?? null;
  const global_actions = useMemo(
    () => (Array.isArray(data?.global_actions) ? data.global_actions : undefined),
    [data?.global_actions]
  );

  const tasks: any = useMemo(() => data && dataSourceConventer(data.results), [
    data,
  ]);

  const selected = (id: string) => {
    navigate({
      pathname: location.pathname,
      search: createQuery({ ...effectiveFilters, id: id }),
    });
  };

  return (
    <TaskListWraper
      limit={limit}
      setLimit={setLimit}
      total={total}
      setOffSet={setOffSet}
      page={page}
      setPage={setPage}
    >
      {taskFilterControls.length > 0 && (
        <Filters
          filtersContols={taskFilterControls}
          resetPagination={resetPagination}
        />
      )}
      <TaskListHeader
        hardcodedControls={hardcodedControls}
        total={total}
        global_actions={global_actions}
      />
      <Table<any>
        columns={baseColumns}
        loading={isFetching}
        dataSource={tasks}
        pagination={false}
        // x: "max-content" keeps columns at their natural width and makes the
        // table scroll horizontally instead of crushing cells on narrow screens.
        scroll={{ y: tableHeight, x: "max-content" }}
        size="small"
        locale={{
          emptyText:
            Object.keys(filters || {}).length > 0 ? (
              <Empty description="Brak pasujących wyników do zaznaczonych filtrów" />
            ) : (
              <Empty />
            ),
        }}
        rowClassName={(record: any) => {
          let calss = "";
          if (record.state.includes("AFTER_DEADLINE")) {
            calss = calss + "after-deadline ";
          }
          if (record?.key.toString() === paramas.id) {
            calss = calss + "selected-row ";
          }
          return calss;
        }}
        onRow={(record:any) => {
          return {
            onClick: () => {
              selected(record.id);
            },
          };
        }}
      />
    </TaskListWraper>
  );
};
